const authz = store => async (to, from, next) => {
    // make sure our user has sufficient permissions
    const userPermissions = store.getters?.["users/current/user"]?.rightsArray || [];
    let canPass = false;

    // make sure nested routes also check permissions of parents
    canPass = to.matched.every(record => {
        const requiredPermissions = record.meta.requiredPermissions || [];

        // no specific permissions defined
        if (!Array.isArray(requiredPermissions) || !requiredPermissions.length) return true;

        // user needs to have all defined permissions
        return requiredPermissions.every(permission => userPermissions.includes(permission));
    });

    // default fallback is profile page currently
    if (!canPass) return next({ path: "/profile" });

    next();
};

export default authz;
